import { getCurrentInstance, ComponentInstance } from '@vue/composition-api';
import { hybrid } from 'hybrid-sdk-common';

export const doLogin = async (): Promise<void> => {
  await new Promise<void>(resolve => {
    hybrid('login', { isReload: 0 }, () => {
      resolve();
    });
  });
};

export default function (): () => Promise<boolean> {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const vm = getCurrentInstance()!.proxy as ComponentInstance;
  return async function (): Promise<boolean> {
    if (!vm.$cmn.isLogin) {
      try {
        await doLogin();
        vm.$cmn.isLogin = true;
        return true;
      } catch (e) {
        console.log(e);
        return false;
      }
    } else {
      return true;
    }
  };
}
